import './PopupEditNote.sass';
import React, { FC, useCallback, useState, useEffect } from 'react';
import { Button, Input } from '$uikit';
import { notesActions, notesSelector, noteSelector } from '$store/notes';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator } from '$hooks';
import { PopupEditProps } from '$core/UserInfo/UserInfo.interface';
import { RootState } from '$store/rootReducer';

export const PopupEditNote: FC<PopupEditProps> = ({ userId, maxNoteLength, onClose }) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const userNote = useSelector((state: RootState) => noteSelector(state, userId));
  const {
    note: { note },
  } = useSelector(notesSelector);
  const [value, setValue] = useState<string>(userNote?.note || note || '');

  useEffect(() => {
    return () => {
      dispatch(notesActions.clearNote());
    };
  }, []);

  const handleSendData = useCallback(() => {
    onClose();
    dispatch(notesActions.setNoteNote(value));
    dispatch(
      notesActions.updateNoteNote({
        userId,
        note: value,
      }),
    );
  }, [value, userId]);

  const handleOnChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  useEffect(() => {
    dispatch(notesActions.setNoteNote(userNote?.note || ''));
  }, [userNote?.note]);

  return (
    <div className="PopupEditNote__container">
      <Input
        type="text"
        maxLength={maxNoteLength}
        placeholder={t('user_info_popup_edit_note_placeholder')}
        value={value}
        multiline
        minHeight={224}
        maxLines={3}
        onChange={handleOnChange}
      />
      <div className="PopupEditNote__text_length">
        {`${value.length}/${maxNoteLength}`}
      </div>
      <Button onClick={handleSendData}>{t('user_info_popup_edit_note_button')}</Button>
    </div>
  );
};
